import { render, staticRenderFns } from "./incremental_search_suggestions.vue?vue&type=template&id=54ebd8c3&lang=pug&"
import script from "./incremental_search_suggestions.vue?vue&type=script&lang=js&"
export * from "./incremental_search_suggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports